package org.moxultimate.topwithmox.wallpaper.di

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.koin.dsl.module
import org.moxultimate.topwithmox.wallpaper.api.WallpaperRepository
import org.moxultimate.topwithmox.wallpaper.details.WallpaperDetailsViewModel
import org.moxultimate.topwithmox.wallpaper.ui.WallpaperViewModel


val wallpaperModule = module {

    // Shared HttpClient — singleton so the underlying JS engine is reused
    single {
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
        }
    }

    // Repository — singleton; holds no mutable state so it is safe to share
    single {
        WallpaperRepository(httpClient = get())
    }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory {
        WallpaperViewModel(repository = get())
    }

    factory {
        WallpaperDetailsViewModel(repository = get())
    }
}